import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, Linkedin, Twitter, Dribbble } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative mt-24 bg-[#0B0B0B] text-[#FFF6E0] rounded-t-[40px] overflow-hidden">
      <div className="absolute inset-0 grain opacity-60 pointer-events-none" />
      <div className="max-w-[1240px] mx-auto px-6 sm:px-10 py-16 sm:py-24 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <p className="font-body text-xs uppercase tracking-[0.25em] text-[#FFC629]">
              Say Hello
            </p>
            <h2 className="font-display text-5xl sm:text-7xl leading-[0.95] mt-4">
              Let's double
              <br />
              your{" "}
              <em className="font-italic-serif text-[#FFC629]">digital</em>{" "}
              growth.
            </h2>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 mt-8 bg-[#FFC629] text-[#0B0B0B] font-semibold rounded-full px-6 py-3 hover:bg-[#FF3D6A] hover:text-[#FFF6E0] transition"
            >
              Start a project <ArrowUpRight size={18} />
            </Link>
          </div>

          <div className="lg:col-span-3 grid grid-cols-2 gap-4 text-sm">
            <div>
              <p className="text-[#FFF6E0]/50 uppercase text-[10px] tracking-[0.25em] mb-3">
                Studio
              </p>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="hover:text-[#FFC629]">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/work" className="hover:text-[#FFC629]">
                    Work
                  </Link>
                </li>
                <li>
                  <Link to="/testimonials" className="hover:text-[#FFC629]">
                    Testimonials
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-[#FFC629]">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p className="text-[#FFF6E0]/50 uppercase text-[10px] tracking-[0.25em] mb-3">
                Services
              </p>
              <ul className="space-y-2 text-[#FFF6E0]/80">
                <li>Brand Direction</li>
                <li>Editorial Creative</li>
                <li>Performance</li>
                <li>Community & PR</li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-3 text-sm">
            <p className="text-[#FFF6E0]/50 uppercase text-[10px] tracking-[0.25em] mb-3">
              Studio HQ
            </p>
            <p className="text-[#FFF6E0]/80 leading-relaxed">
              4th Floor, Camac Studios
              <br />
              Camac Street, Kolkata 700016
              <br />
              India
            </p>
            <p className="mt-4 text-[#FFF6E0]/80">
              admin@illustrativedigital.com
            </p>
            <p className="text-[#FFF6E0]/80">+91 33 4001 2020</p>

            <div className="flex items-center gap-3 mt-6 text-[#FFC629]">
              <a href="#" aria-label="Instagram" className="hover:text-white">
                <Instagram size={18} />
              </a>
              <a href="#" aria-label="LinkedIn" className="hover:text-white">
                <Linkedin size={18} />
              </a>
              <a href="#" aria-label="Twitter" className="hover:text-white">
                <Twitter size={18} />
              </a>
              <a href="#" aria-label="Dribbble" className="hover:text-white">
                <Dribbble size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FFF6E0]/10 flex flex-col sm:flex-row justify-between text-xs text-[#FFF6E0]/50 gap-3">
          <p>
            Since 2016 <span className="rule-v" /> Top 15 in India{" "}
            <span className="rule-v" /> 110 brands worldwide
          </p>
          <p>Kolkata → Worldwide</p>
        </div>
      </div>
    </footer>
  );
}
